/**
 * The result-section wrappers the "Hide owned assets" filter targets: the
 * filter sets `data-hide-owned` on this element, and the searchOwnership.css
 * rule hides any owned result card beneath it. Listed explicitly per page
 * (rather than a `$="-result-section"` suffix match) so a future
 * `*-result-section` wrapper doesn't silently opt into ownership hiding.
 */
export const RESULT_SECTION_SELECTOR =
  '[data-test="search-result-section"], [data-test="listing-result-section"]';
